import {
  SIGNUP_HANDLE_CHANGE,
  LOGIN_HANDLE_CHANGE,
  PLAN_SIZE_CHANGE,
  OPTED_PLAN,
  CHECK_OUT_PAYMENT,
  PAYMENT_CLOSE,
  PAYMENT_WEBHOOK,
  PAYMENT_ACKNOWLEDGE,
  PROFILE_HANDLE_CHANGE,
  PASSWORD_HANDLE_CHANGE,
  FORGOT_PASSWORD_HANDLE_CHANGE,
  RESEND_ACTIVATION_HANDLE_CHANGE,
  CLOSE_CART,
} from "./constants";

export function loginHandleChange(name, value) {
  return { type: LOGIN_HANDLE_CHANGE, name, value };
}

export function signupHandleChange(name, value) {
  return { type: SIGNUP_HANDLE_CHANGE, name, value };
}

export function planSizeChange(value) {
  //console.log("Change Plan : " + JSON.stringify(value));
  return {
    type: PLAN_SIZE_CHANGE,
    size: value.size,
    ratecardList: value.ratecardList,
  };
}

export function optedPlan(value) {
  // console.log("opted Plan : " + JSON.stringify(value));
  return { type: OPTED_PLAN, planDetails: value.planDetails };
}

export function checkOutPayment(invoiceInfo) {
  // console.log("check Out Payment : " + JSON.stringify(invoiceInfo));
  return { type: CHECK_OUT_PAYMENT, invoiceData: invoiceInfo.invoiceInfo };
}

export function closeCart() {
  return { type: CLOSE_CART };
}

export function paymentClose() {
  //console.log("opted Plan : " + JSON.stringify(value));
  return { type: PAYMENT_CLOSE };
}

export function paymentWebhook(value) {
  return {
    type: PAYMENT_WEBHOOK,
    paymentDetails: value.paymentDetails,
    invoiceInfo: value.invoiceInfo,
  };
}
export function paymentAcknowledge() {
  return { type: PAYMENT_ACKNOWLEDGE };
}
export function profileHandleChange(name, value) {
  return { type: PROFILE_HANDLE_CHANGE, name, value };
}

export function passwordHandleChange(name, value) {
  return { type: PASSWORD_HANDLE_CHANGE, name, value };
}

export function forgotPasswordHandleChange(name, value) {
  return { type: FORGOT_PASSWORD_HANDLE_CHANGE, name, value };
}

export function resendActivationHandleChange(name, value) {
  return { type: RESEND_ACTIVATION_HANDLE_CHANGE, name, value };
}



// WEBPACK FOOTER //
// ./src/common/actions.js